import React, { useCallback, useEffect, useState } from 'react'
import TableCustom from '../../../components/table/tableCustom';
import { ButtonBack, ButtonOutlined, ButtonPrimary } from '../../../components/button/ButtonCustoms';
import ContentHeading from '../../../components/layout/content/ContentHeading';
import InputTextField from '../../../components/input/inputTextField';
import { RemoveRedEyeOutlined, SearchOutlined } from '@mui/icons-material';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import TableRowCommon from '../../../components/table/TableRowCommon';
import { dateTimeToView } from '../../../utils/date.utils';
import SwitchCustom from '../../../components/switch/SwitchCustom';
import { useDispatch } from 'react-redux';
import ModalCustom from '../../../components/modal/ModalCustom';
import { alertActive, swalError, swalSuccess } from '../../../components/alert/swal';
import OptionsButtonCustom from '../../../components/button/OptionsButtonCustom';
import { MeetingTypeApi } from '../../../api/meeting-type/meeting-type.api';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { useTranslation } from 'react-i18next';
import { ThesisCategoryApi } from '../../../api/thesis-category/thesis-category.api';
import { ThesisTypeApi } from '../../../api/thesis-type/thesis-type.api';
import UploadFile from '../../../components/upload/UploadFile';
import { RulesRegulationsApi } from '../../../api/rules-regulations/rules-regulations.api';
import { Typography } from '@mui/material';
import { ReactComponent as Document } from '../../../assets/icons/document.svg'

const defaultState = {
    id_thesis_type: 0,
    rules_regulations_name: undefined,
}
export default function RulesRegulations() {
    const navigate: NavigateFunction = useNavigate();
    const { t } = useTranslation();
    const [data, setData] = useState<any[]>([]);
    const dispatch = useDispatch();
    const [search, setSearch] = useState<any>('')
    const [form, setForm] = useState<any>(defaultState)
    const [type, setType] = useState<string>("CREATE");
    const [file, setFile] = useState<any>();

    const [open, setOpen] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const headCells = [

        {
            id: "leave_type_name",
            width: '400px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("ชื่อไฟล์"),
        },

        {
            id: "user_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("ผู้ที่สร้าง/ปรับปรุงล่าสุด"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("วันที่สร้าง/ปรับปรุงล่าสุด"),
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '100px',
            label: "action",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const { id_rules_regulations, rules_regulations_name, status, modified, modified_date } =
            objData;

        const objRenderData = {
            key: id_rules_regulations,
            id: no,
            obj: objData,
            columns: [

                {
                    option: "TEXT",
                    align: "start",
                    label: rules_regulations_name,
                },

                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: modified ? (
                        <>
                            {modified?.title +
                                " " +
                                modified?.first_name +
                                " " +
                                modified?.last_name}
                        </>
                    ) : (
                        "-"
                    ),
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateTimeToView(modified_date) : "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <OptionsButtonCustom
                            enableView
                            enableEdit
                            enableDelete
                            onViewClick={() => {
                                setOpen(true)
                                // getDetail(id_course_of_study)
                                setFile(objData)
                                setForm(objData)
                                setType("VIEW")
                            }}

                            onEditClick={() => {
                                setOpen(true)
                                // getDetail(id_course_of_study)
                                setForm(objData)
                                setFile(objData)
                                setType("EDIT")
                            }}
                            onDeleteClick={() => {
                                alertActive('ยืนยันที่จะลบ หรือไม่?', '', 'ยืนยัน', 'ยกเลิก', () => {
                                    handleDelete(id_rules_regulations)
                                })
                            }} />
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };

    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (search) condition = { ...condition, keyword: search };

            const res = await RulesRegulationsApi.list(condition);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit,]);

    useEffect(() => {
        loadData();
    }, [loadData]);
    const handleClose = async () => {
        setOpen(false)
        setForm(defaultState)
        setFile(null)
    }
    const handleCreate = async () => {

        const formData = new FormData();

        //DRAFT
        formData.append('file', file);
        formData.append('rules_regulations_name', form?.rules_regulations_name);
        formData.append('status', 'active');
        if (type === 'EDIT') {
            await RulesRegulationsApi.patch(formData, form.id_rules_regulations).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('แก้ไขเอกสาร เรียบร้อยแล้ว'))
                    loadData()
                    handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            })

        } else {
            await RulesRegulationsApi.post(formData).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('เพิ่มเอกสาร เรียบร้อยแล้ว'))
                    loadData()
                    handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            })

        }
    }

    const handleDelete = async (id: any) => {
        await RulesRegulationsApi.delete(id).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('ลบเอกสาร เรียบร้อยแล้ว'))
                loadData()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })

    }
    const handleDownload = async (id: any) => {
        await RulesRegulationsApi.download(id).then((res: any) => {
            if (res.status < 300) {
                // window.open(process.env.REACT_APP_FILE_BASE_API + '/' + file?.file_path + file?.file_name, '_blank');
                const blobFile = new Blob([res?.data], { type: file?.file_type })
                const url = URL.createObjectURL(blobFile);
                 window.open(url, '_blank');

                console.log(res.data);
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })

    }

    function formatBytes(bytes: any, decimals = 2) {
        if (!+bytes) return '0 Bytes'

        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

        const i = Math.floor(Math.log(bytes) / Math.log(k))

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }
    console.log(file);
    return (
        <div>
            <ContentHeading
                title={t("รูปแบบ/กฎระเบียบข้อบังคับ")}
                detail={t("กรุณาเลือกรายการที่ท่านต้องการ")}
            />

            <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-3 sm:col-span-12">
                    <InputTextField
                        startAdornment={<SearchOutlined />}
                        placeholder={t("ค้นหาชื่อเรื่อง")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                            setSearch(e.target.value)
                        }}
                        value={search || ''}
                    />
                </article>

                <article
                    className="w-full col-span-12 md:col-span-4 lg:col-span-9 sm:col-span-12"
                    style={{
                        display: "flex",
                        justifyContent: "end",
                    }}
                >
                    <ButtonPrimary
                        onClick={() => {
                            // navigate(routeName.cms.ManageLeaveType + `/create`);
                            setOpen(true)
                            setType('CREATE')
                        }}
                        mode="add"
                        buttonName={t("เพิ่มไฟล์")}
                    />
                </article>
            </div>

            <section className="w-full mt-10">
                <TableCustom
                    tableMinWidth={1440}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={
                        data.map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>
            <ModalCustom title={type === 'CREATE' ? t('เพิ่มเอกสาร') : t('แก้ไขข้อมูลเอกสาร')} subTitle={t('กรุณาเลือกรายการที่ท่านต้องการ')} open={open} component={
                <div className='flex flex-col gap-4'>

                    <div>
                        <InputTextField
                            heading={t("เอกสาร")}
                            placeholder={t("ระบุชื่อประเภท")}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                // handleChangeValueSearch("leave_type_name", e.target.value);
                                setForm({ ...form, rules_regulations_name: e.target.value })
                            }}
                            value={form.rules_regulations_name}

                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px', width: "100%" }}>
                        {file ?
                            <div style={{
                                border: "2px dotted #C1C3C7",
                                borderRadius: "10px",
                                padding: "15px 15px",
                                display: 'flex',
                                justifyContent: 'space-between',
                                width: '100%'
                            }}>
                                <div style={{ display: 'flex', gap: '10px' }}>
                                    <Document />
                                    <div style={{ display: "flex", flexDirection: 'column' }}>
                                        <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{file?.file_name || file?.name}</Typography>
                                        <Typography sx={{ fontSize: '14px', }} >ขนาดไม่เกิน {formatBytes(file?.file_size || file?.size)}</Typography>
                                    </div>
                                </div>

                                {type !== 'VIEW' && <ButtonOutlined
                                    onClick={() => {
                                        // handleSubmit(inputValueFormStudent.information);
                                        setFile(null)
                                    }}
                                    buttonName={t('ลบ')}
                                    btnProps={{
                                        width: "70px",
                                        // border: '#0F9F0C'
                                    }}
                                />}
                                {type === 'VIEW' && <ButtonOutlined
                                    onClick={() => {
                                        // handleSubmit(inputValueFormStudent.information);
                                        // window.open(process.env.REACT_APP_FILE_BASE_API + '/' + file?.file_path + file?.file_name, '_blank');
                                        handleDownload(file?.id_rules_regulations)

                                    }}
                                    buttonName={t('ดาวน์โหลดไฟล์')}
                                    btnProps={{
                                        width: "150px",
                                        // border: '#0F9F0C'
                                    }}
                                />}
                            </div> :

                            <UploadFile

                                onDrop={(file) => {
                                    setFile(file[0]);
                                }}
                                // enableFormatImage
                                onDeleteFile={() => {
                                    setFile(null);
                                }}
                                noClick={false}
                            // formatText='ขนาดไม่เกิน 10MB'
                            // customFormat={["image/jpeg", "image/jpg", "image/png"]}

                            />
                        }
                    </div>
                    <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                handleClose()
                            }}
                            buttonName={'ยกเลิก'}
                        />
                        {type !== 'VIEW' && <ButtonPrimary
                            onClick={() => {
                                handleCreate()
                            }}
                            mode='add'
                            buttonName={'ยืนยัน'}
                        />}
                    </div>
                </div>
            } />
        </div>
    )
}
